import script from "./ImpostorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostorCard.vue?vue&type=script&setup=true&lang=js"

import "./ImpostorCard.vue?vue&type=style&index=0&id=f4532758&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4532758"]])

export default __exports__